// AppliedFilters present a list of filters that have been applied.
// This code is not intake-specific

import React from 'react';
import PropTypes from 'prop-types';
import LinkButton from 'SF/LinkButton';

import appliedFilterStyles from './AppliedFilters.scss';

const clearButtonLabel = (text) => `Remove filter on \u201c${text}\u201d`;

const FilterRow = ({id, label, displayValue, onClearFilter}) =>
  <tr>
    <td>{label}</td>
    <td>{displayValue}</td>
    {onClearFilter && (
      <td className={appliedFilterStyles['filter-remove-cell']}>
        <button className={"remove-filter " + appliedFilterStyles['plain-button']}
                aria-label={clearButtonLabel(label)}
                title={clearButtonLabel(label)}
                onClick={() => onClearFilter(id)}>
          <i className="fa fa-remove remove-filter" aria-hidden="true"/>
        </button>
      </td>
    )}
  </tr>;

FilterRow.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  displayValue: PropTypes.string.isRequired,

  onClearFilter: PropTypes.func,
};

const FilterList = ({columnLabels, filters, onClearFilter}) => {
  if (filters.length === 0) {
    return null;
  }

  return (
    <table className={"applied-filters minimal " + appliedFilterStyles['filter-table']}>
      <colgroup>
        <col className={appliedFilterStyles['filter-title']} />
        <col className={appliedFilterStyles['filter-value']} />
        <col className={appliedFilterStyles['filter-remove']} />
      </colgroup>

      <thead className={appliedFilterStyles['filter-header']}>
        <tr>
          <th scope="col">{columnLabels.question}</th>
          <th scope="col">{columnLabels.answer}</th>
        </tr>
      </thead>

      <tbody>
        {filters.map(filter =>
          <FilterRow key={filter.id}
                     id={filter.id}
                     label={filter.label}
                     displayValue={filter.displayValue}

                     onClearFilter={onClearFilter}
          />
        )}
      </tbody>
    </table>
  );
};

const filterCondition = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  displayValue: PropTypes.string.isRequired,
});

FilterList.propTypes = {
  onClearFilter: PropTypes.func,

  columnLabels: PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
  }).isRequired,

  filters: PropTypes.arrayOf(filterCondition).isRequired
};


const FilterControls = ({children}) =>
  <div className={appliedFilterStyles['filter-controls']}>
    {children}
  </div>;

const AppliedFilters = ({columnLabels, filters, onClearFilter}) => {
  if (filters.length === 0) {
    return null;
  }

  const clearAllFilters = () => filters.forEach(filter => onClearFilter(filter.id));
  return (
    <div className="applied-filters">
      {onClearFilter && (
        <FilterControls>
          <LinkButton className="clear-all-filters"
                      onClick={clearAllFilters}>
            Clear all filters
          </LinkButton>
        </FilterControls>
      )}

      <FilterList columnLabels={columnLabels}
                  filters={filters}
                  onClearFilter={onClearFilter} />
    </div>
  )
};

AppliedFilters.defaultProps = {
  columnLabels: {
    question: "Question",
    answer: "Answer",
  }
};

AppliedFilters.propTypes = {
  columnLabels: PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
  }).isRequired,

  filters: PropTypes.arrayOf(filterCondition).isRequired,

  onClearFilter: PropTypes.func,
};

export default AppliedFilters;
